<template>
  <div class="page activity-rule">
    <navigation class="header">活动规则</navigation>
    <div class="body">
      <div class="section">
        <div class="title">
          活动时间
        </div>
        <div class="desc">
          {{ start | date('YYYY/MM/DD') }} - {{ end | date('YYYY/MM/DD') }}
        </div>
      </div>
      <div class="section" v-for="(item, index) in rules" :key="index">
        <div class="title">
          {{ item.title }}
        </div>
        <div class="desc">
          {{ item.desc }}
        </div>
      </div>
    </div>
    <footer style="color: #BA8536;">活动所有解释权归天美贷所有</footer>
  </div>
</template>

<script>
export default {
  name: 'relending-rule',
  data () {
    return {
      start: Number(this.$route.query.start),
      end: Number(this.$route.query.end),
      rules: [
        {
          title: '活动内容',
          desc: '天美贷活动资格用户有抽取红包资格，根据抽取的免息红包天数，在规定15天激活期限内进行借款，正常还首期则可默认使用该优惠券。'
        },
        {
          title: '奖品使用规则及有效期',
          desc: '活动期间，资格用户进入活动页面领取免息红包，抽取红包15个自然日内（含当天）提现激活，正常/提前归还首期，则默认使用。每个用户仅能领取1次免息红包。'
        },
        {
          title: '奖品发放方式',
          desc: '当完成该笔订单首期正常或提前还款，对应免息金额将在5个工作日内现金返现至绑定银行卡，如发生逾期则该优惠券对应返现金额自动失效，您将不能再享受该免息优惠。'
        },
        {
          title: '奖品查看方式',
          desc: '您可以通过天美贷APP-我的-我的券包或该活动对应的详情页进行查看。'
        }
      ]
    }
  },
  mounted () {
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less">
@import "../../../assets/less/mixin.less";

.page.activity-rule {
    background: #A7BFFF;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .header {
        flex-shrink: 0;
    }
    .body {
        flex: 1;
        flex-shrink: 0;
        margin: 40px 40px 0;
        background-color: #fff;
        border-radius: 30px;
        padding: 30px 30px 100px;
        .section {
            .title {
                padding-top: 50px;
                font-size: 32px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 45px;
            }
            .desc {
                border-radius: 16px;
                background-color: #fff;
                padding: 20px 0;
                font-size: 26px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 40px;
                margin-top: 10px;
            }
        }
    }

    footer {
        flex-shrink: 0;
        font-size: 22px;
        color: #fff;
        text-align: center;
        margin-top: 65px;
        margin-bottom: 45px;
    }
}
</style>
